import Fetch from "utils/fetch";

export interface ServiceResponse {
  AllSuccess: boolean;
  Results: ResultItem[];
}

export interface ResultItem {
  Type: number;
  Message: string;
}

export const downloadDynamicInventoryPolicy = (): Promise<string> => {
  return Fetch.get(`dynamic-inventory-policies:export`).then(({data}) => data);
} 

export const updateDynamicInventoryPolicyJson = (policyData: any): Promise<ServiceResponse> => {
  return Fetch.put(`dynamic-inventory-policies:import`, policyData).then(({data}) => data);
}

export const downloadDynamicInventoryPolicyTemplate = (): Promise<string> => {
  return Fetch.get(`dynamic-inventory-policies:export-template`).then(({data}) => data);
}
